/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'

const getUser = param => {
  return axiosInstance.post(`/api/gcadmin/v1/admin/getAdmin?filter=`+ JSON.stringify(param)).then(res => res.data)
}
const getUsersInfo = param => {
  return axiosInstance.get(`/api/gcadmin/v1/getUsersInfo`, param).then(res => res.data)
}
const getUsersCount = param => {
  return axiosInstance.get(`/api/gcadmin/v1/user/getUsersCount`, param).then(res => res.data)
}
const login = (username, password) => {
  return axiosInstance.post(`/api/gcadmin/v1/admin/adminLogin`, {username, password}).then(res => JSON.stringify(res.data))
}
const register = (user) => {
  return axiosInstance.post(`/api/gcadmin/v1/admin/register`, user).then(res => res.data)
} 
const getUserMe = param => {
  return axiosInstance.get(`/api/gcadmin/v1/admin/me`, param).then(res => res.data)
}
const getUserById = (userid) => {
  return axiosInstance.get(`/api/gcadmin/v1/user/{userId}?id=`+userid).then(res => res.data)
}
const patchPassword = param => {
  return axiosInstance.patch(`/api/v1/user/me/password`, param).then(res => res.data)
}

const patchUserMe = param => {
  return axiosInstance.patch(`/api/gcadmin/v1/admin/me`, param).then(res => res.data)
}

const getAllUsers = param => {
  return axiosInstance.get(`/api/gcadmin/v1/admin/getAllAdmins?filter=`+ JSON.stringify(param)).then(res => res.data)
}
export {
  getUser,
  login,
  getUserMe,
  register,
  patchPassword,
  patchUserMe,
  getUsersInfo, 
  getAllUsers,
  getUsersCount,
  getUserById
}
